import { render, staticRenderFns } from "./CardHabitsListSkeleton.vue?vue&type=template&id=f679dce8"
import script from "./CardHabitsListSkeleton.vue?vue&type=script&lang=js"
export * from "./CardHabitsListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports